import uuid from 'react-uuid';

export let session_id = uuid();
